var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    stroke: "#929292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6667 55V41.2C39.6667 39.7688 39.6667 39.0531 39.3881 38.5065C39.1431 38.0256 38.7522 37.6347 38.2713 37.3897C37.7246 37.1111 37.009 37.1111 35.5778 37.1111H28.4222C26.991 37.1111 26.2754 37.1111 25.7287 37.3897C25.2478 37.6347 24.8569 38.0256 24.6119 38.5065C24.3333 39.0531 24.3333 39.7688 24.3333 41.2V55M9 19.2222C9 23.4564 12.4325 26.8889 16.6667 26.8889C20.9008 26.8889 24.3333 23.4564 24.3333 19.2222C24.3333 23.4564 27.7658 26.8889 32 26.8889C36.2342 26.8889 39.6667 23.4564 39.6667 19.2222C39.6667 23.4564 43.0991 26.8889 47.3333 26.8889C51.5675 26.8889 55 23.4564 55 19.2222M17.1778 55H46.8222C49.6847 55 51.116 55 52.2093 54.4429C53.171 53.9529 53.9529 53.171 54.4429 52.2093C55 51.116 55 49.6847 55 46.8222V17.1778C55 14.3153 55 12.884 54.4429 11.7907C53.9529 10.829 53.171 10.0471 52.2093 9.55708C51.116 9 49.6847 9 46.8222 9H17.1778C14.3153 9 12.884 9 11.7907 9.55708C10.829 10.0471 10.0471 10.829 9.55708 11.7907C9 12.884 9 14.3153 9 17.1778V46.8222C9 49.6847 9 51.116 9.55708 52.2093C10.0471 53.171 10.829 53.9529 11.7907 54.4429C12.884 55 14.3153 55 17.1778 55Z",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/vendor.5ee7b297e09a7f77cbc274e941782d76.svg";
export { ForwardRef as ReactComponent };